import React, { FC, useCallback } from 'react'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { FlexRow } from 'components/Flex'
import { OrderCardAccordionButton } from 'components/Card'
import { useToggle } from 'hooks/form'
import { CautionButton } from 'components/Button'
import format from 'date-fns/format'
import { useDispatch } from 'react-redux'
import { openCautionModal } from 'reducks/modal/operations'
import { cancelCheckout } from 'reducks/checkout/operations'

type Props = {
  cancelDeadline: Date
  checkoutId: string
}

const OrderCardCancel: FC<Props> = React.memo((props) => {
  const { cancelDeadline, checkoutId } = props
  const dispatch = useDispatch()
  const [openCancel, toggle] = useToggle(false)
  const openModal = useCallback(() => {
    dispatch(
      openCautionModal(
        '削除する',
        'キャンセル',
        '一度キャンセルした注文は、元に戻すことができませんがよろしいですか？',
        () => dispatch(cancelCheckout(checkoutId)),
        'この注文をキャンセルします'
      )
    )
  }, [checkoutId])
  const deadline = cancelDeadline ? format(cancelDeadline, 'M月d日HH:mm') : ''
  return (
    <>
      <Spacer size={16} />
      <FlexRow justifyContent={'center'}>
        <OrderCardAccordionButton
          dataCy={'cancel'}
          label={'キャンセルの問い合わせがあった場合'}
          toggle={toggle}
          open={openCancel}
        />
      </FlexRow>
      {openCancel && (
        <>
          <Spacer size={16} />
          <CautionButton
            dataCy={'cancel'}
            label={'この注文をキャンセルする'}
            onClick={openModal}
            size={'medium'}
            type={'outlined'}
          />
          <Spacer size={16} />
          <p className={text.font_small}>
            <span data-cy={'order-card-cancel-deadline-span'} className={text.font_bold}>
              この注文は、{deadline}までキャンセルできます。
            </span>
            <br />
            ※キャンセル期限はお客さまのカード会社によって異なります。予めご了承ください。
          </p>
        </>
      )}
    </>
  )
})

export default OrderCardCancel
